import withIFrameAdditives from './iframe-additives';
import setupBaseURL from './iframe-additives/setup-base-url';
import bindings from './bindings';

export default {
  bindings,
  withIFrameAdditives,
  setupBaseURL,
};
